import { render } from "./AudioPlayer.vue?vue&type=template&id=22f6ff00&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=22f6ff00&lang=scss&scoped=true"
import "./AudioPlayer.vue?vue&type=style&index=1&id=22f6ff00&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f6ff00"]])

export default __exports__